export interface GlobalReportType {
  slug: string;
  title: string;
  description?: string;
  category?: string;
}

export const GLOBAL_REPORT_TYPES: GlobalReportType[] = [
  // Geographic
  {
    slug: "iran",
    title: "Iran Conflict",
    description:
      "US/Israel attacks, Iranian strikes, global impact, Strait of Hormuz, regional proxies",
    category: "Geographic",
  },
  {
    slug: "china",
    title: "China",
    description:
      "Policy, economy, tech controls, Taiwan risk signals, military posture",
    category: "Geographic",
  },
  {
    slug: "us-policy",
    title: "US Policy & Political Risk",
    description:
      "Elections, Congress, industrial policy, regulatory shocks, fiscal/monetary shifts",
    category: "Geographic",
  },
  {
    slug: "europe",
    title: "Europe Politics & Regulation",
    description:
      "Competition policy, CBAM/ESG enforcement, industrial policy, security posture, major elections",
    category: "Geographic",
  },
  {
    slug: "russia-ukraine",
    title: "Russia–Ukraine & Eastern Europe",
    description:
      "Battlefield-to-markets: energy, sanctions, shipping, cyber, NATO eastern flank",
    category: "Geographic",
  },
  {
    slug: "mena",
    title: "Middle East, North Africa & Gulf States",
    description:
      "Red Sea, Levant, Iran dynamics, shipping/energy risk, GCC industrial policy, sovereign wealth flows, normalization, logistics/ports",
    category: "Geographic",
  },
  {
    slug: "india",
    title: "India & South Asia",
    description:
      "Regulatory shifts, elections/state politics, manufacturing policy, digital governance, Pakistan/Bangladesh dynamics",
    category: "Geographic",
  },
  {
    slug: "southeast-asia",
    title: "Southeast Asia & ASEAN",
    description:
      "Supply chain diversification, China+1 dynamics, elections, digital economy regulation, maritime disputes",
    category: "Geographic",
  },
  {
    slug: "japan-korea",
    title: "Japan, Korea & Pacific",
    description:
      "Semiconductor alliances, alliance politics, demographics, trade, defense posture",
    category: "Geographic",
  },
  {
    slug: "latin-america",
    title: "Latin America",
    description:
      "Elections, resource nationalism, FX/sovereign risk, nearshoring, security/corruption enforcement",
    category: "Geographic",
  },
  {
    slug: "africa",
    title: "Africa",
    description:
      "Politics, mining fiscal terms, ports/logistics, debt/IMF dynamics, great-power competition",
    category: "Geographic",
  },
  // Sector
  {
    slug: "energy",
    title: "Energy & Oil/Gas",
    description:
      "Supply disruptions, OPEC+ signals, LNG constraints, refinery outages, strategic reserves, energy security",
    category: "Sector",
  },
  {
    slug: "minerals",
    title: "Critical Minerals & Mining",
    description:
      "Royalties, permitting, resource nationalism, ESG litigation, China processing leverage, supply bottlenecks",
    category: "Sector",
  },
  {
    slug: "ai-tech",
    title: "AI & Strategic Technology",
    description:
      "Compute controls, model governance, chip supply chain, sovereign AI, data localization, talent flows",
    category: "Sector",
  },
  {
    slug: "defense",
    title: "Defense, Space & Strategic Security",
    description:
      "Spending trends, procurement, alliance shifts, arms flows, satellite constellations, GPS/PNT, launch access, subsea cables",
    category: "Sector",
  },
  {
    slug: "health",
    title: "Health, Pharma & Biosecurity",
    description:
      "Pandemic preparedness, drug supply chains, API sourcing from China/India, health governance",
    category: "Sector",
  },
  {
    slug: "climate",
    title: "Climate, Energy Transition & Green Industrial Policy",
    description:
      "Carbon markets, CBAM, green subsidies, transition minerals demand, climate litigation",
    category: "Sector",
  },
  // Global Dynamics
  {
    slug: "trade-sanctions",
    title: "Trade, Sanctions & Economic Statecraft",
    description:
      "Tariffs, anti-dumping, export controls, designations, secondary sanctions, evasion typologies, rules-of-origin, compliance choke points",
    category: "Global Dynamics",
  },
  {
    slug: "supply-chains",
    title: "Supply Chains, Shipping & Trade Compliance",
    description:
      "Red Sea, Hormuz, Panama, rail/port strikes, war-risk pricing, import bans, forced labor traceability, ESG enforcement",
    category: "Global Dynamics",
  },
  {
    slug: "cyber",
    title: "Cyber, Digital Regulation & Data Sovereignty",
    description:
      "State-linked campaigns, ransomware, platform liability, privacy enforcement, cross-border data transfer",
    category: "Global Dynamics",
  },
  {
    slug: "markets",
    title: "Global Markets & Financial Risk",
    description:
      "Volatility catalysts, rates/FX stress points, commodity correlations, sovereign debt, capital flows",
    category: "Global Dynamics",
  },
];

export function getGlobalReportTypeBySlug(
  slug: string,
): GlobalReportType | undefined {
  return GLOBAL_REPORT_TYPES.find((t) => t.slug === slug);
}
